import { FormattedMessage, useIntl } from "react-intl";
import styles from "./index.module.scss";
import CALogo from "../../../../assets/images/logos/ca_logo.png";
import DragContainer from "../../dragContainer/dragContainer.container.jsx";
import { connect } from "react-redux";
import * as action from "../../../../reduxStore/actions/mainNav";
import * as mainAction from "../../../../reduxStore/actions/main";
import { MISC_INFO, MODULES } from "../../../../reduxStore/actions/main";
import { withRouter } from "react-router-dom";
import { AppOverlayIFrame } from "../../../../functions/classes/miscelleanous.classes.js";
import StandardButton from "../../buttons/standard.button.jsx";
import { useEffect, useRef, useState } from "react";
import { isMobile } from "react-device-detect";
import { animated, config, useSpring } from "react-spring";
import RoundedIcon from "../../buttons/roundedIcon.component.jsx";
import StandardCard from "../../cards/StandardCard.card.jsx";
import { getQueryParams } from "../../../../app/RouteWithSubRoutes";
import { toggleDebugMode } from "../../../../functions/helper/helpers.functions.js";
import { CUSTOM_STYLE_PATH } from "../../../../app/app.sideEffects/useStyles.sideEffects.js";
import StandardInstruction from "../../text/standardInstruction.component.jsx";
import { setProperties } from "../../../../reduxStore/actions/settings.js";
import {
  appVersion,
  piKey,
} from "../../../../app/app.sideEffects/useURLParams.sideEffects";
import { pageNames } from "../../../../reduxStore/reducers/main";
import ContactModal from "../contactModal";

function MainMenu(props) {
  const initRender = useRef(true);

  useEffect(() => {
    if (initRender.current) return;
    props.setStatus("close");
  }, [props.currentFeature]);

  useEffect(() => {
    initRender.current = false;
  }, []);

  // Bei Mobile soll eine Karte von unten nach oben fahren, bei Dekstop eine Sidebar
  if (isMobile) {
    return (
      <DragContainer
        status={"preOpen"}
        keepPreOpenContent={true}
        preOpenContent={HeaderContent({ ...props })}
        handleCloseEnd={() => props.setStatus("close")}
      >
        <MainContent {...props} />
      </DragContainer>
    );
  } else {
    return (
      <DesktopMenu onClosedEnd={() => props.setStatus("close")}>
        <HeaderContent {...props} />
        <MainContent {...props} />
      </DesktopMenu>
    );
  }
}
const MainContent = (props) => {
  const [showContactForm, setShowContactForm] = useState(false);
  const host = window.location.host;
  const subdomain = host.split(".")[0];

  return (
    <>
      {showContactForm && (
        <ContactModal setShowContactForm={setShowContactForm} />
      )}
      <div className={"pl-3 pr-3"}>
        <MainBlock title={<FormattedMessage id="menu.legal" />}>
          <LegalItems
            setCurrentAppOverlay={props.setCurrentAppOverlay}
            setShowContactForm={setShowContactForm}
          />
        </MainBlock>
        <MainBlock title={<FormattedMessage id="menu.appInformation" />}>
          <AppInfos
            setCurrentAppOverlay={props.setCurrentAppOverlay}
            appVersion={appVersion}
            subdomain={subdomain}
            setProperties={props.setProperties}
          />
        </MainBlock>
      </div>
    </>
  );
};
const HeaderContent = (props) => {
  const imageURL = `${CUSTOM_STYLE_PATH}/img/customerLogo.png`;

  return (
    <div className={"pl-3 pr-3"}>
      <div className={"ml-auto mb-3"}>
        <img className={styles.clientLogo + " ml-auto"} src={imageURL} />
      </div>
      <MainBlock title={<FormattedMessage id="menu.menu" />}>
        <NavItems
          isTerminal={props.isTerminal}
          history={props.history}
          setStatus={props.setStatus}
          piKey={props.piKey}
          setCurrentAppOverlay={props.setCurrentAppOverlay}
          location={props.location}
          triggerPageLoad={props.triggerPageLoad}
          language={props.language}
          properties={props.properties}
        />
      </MainBlock>
    </div>
  );
};
const DesktopMenu = ({ children, status, onClosedEnd }) => {
  // setzen der Animation, die nur die y-Bewegung steuert
  const [springProps, springAPI] = useSpring(() => ({
    from: {
      transform: "translateX(-200px)",
      opacity: 0,
    },
    to: { opacity: 1, transform: "translateX(0)" },
    config: config.stiff,
  }));

  const containerRef = useRef();

  const handleClose = () => {
    springAPI.start({
      to: {
        transform: "translateX(-200px)",
        opacity: 0,
      },
      onRest: onClosedEnd,
    });
  };

  // useEffect(() => {
  //   switch (status) {
  //     case "open":
  //       handleOpen();
  //       break;
  //     case "closed":
  //       handleClose();
  //       break;
  //   }
  // }, [status]);

  return (
    <animated.div
      ref={containerRef}
      className={`${styles.desktopMenuContainer} p-2`}
      style={springProps}
    >
      <StandardCard className={`h-100 d-flex flex-column ${styles.noPadding}`}>
        <div className={"d-flex p-3"}>
          <RoundedIcon
            icon={["fal", "times"]}
            divClass={"ml-auto roundedIcon--close"}
            onClick={handleClose}
          />
        </div>
        <div className={"overflow-auto"}>{children}</div>
      </StandardCard>
    </animated.div>
  );
};

const MainBlock = ({ title, children }) => {
  return (
    <div>
      <span className={`${styles.menuTitle} menue-headtype mr-5`}>{title}</span>
      <nav className="navbar padding-0 text-left">
        <ul className="navbar-nav w-100">{children}</ul>
      </nav>
    </div>
  );
};
const NavItems = ({
  setStatus,
  location,
  triggerPageLoad,
  history,
  piKey,
  isTerminal,
  setCurrentAppOverlay,
  language,
  properties,
}) => {
  const intl = useIntl();
  const navItems = [
    {
      id: "map",
      icon: "map",
      text: intl.formatMessage({ id: "menu.map" }),
      action: () => {
        triggerPageLoad();
        history.push(`/${pageNames.map}/${pageNames.info}/${getQueryParams()}`);
      },
    },
  ];

  if (MODULES.hatTelefonbuch) {
    navItems.push({
      id: "phonebook",
      icon: "phone",
      text: intl.formatMessage({ id: "menu.phonebook" }),
      action: () => {
        history.push(`/${pageNames.phonebook}/${getQueryParams()}`);
        triggerPageLoad();
      },
    });
  }

  if (MODULES.hatVeranstaltungen) {
    navItems.push({
      id: "event",
      icon: "calendar",
      text: intl.formatMessage({ id: "menu.event" }),
      action: () => {
        history.push(`/${pageNames.events}/${getQueryParams()}`);
        triggerPageLoad();
      },
    });
  }

  if (MODULES.hatNeuigkeiten) {
    navItems.push({
      id: "news",
      icon: "star",
      text: intl.formatMessage({ id: "menu.news" }),
      action: () => {
        history.push(`/${pageNames.news}/${getQueryParams()}`);
        triggerPageLoad();
      },
    });
  }

  if (mainAction.APP_SETTINGS) {
    if (mainAction.APP_SETTINGS.customLinks) {
      /** @type {{
        "url": string,
        "text": {
            "de_DE": string,
            "en_US": string
        },
        "faIcon": string,
        "debugModeOnly": boolean
      }[]} */
      const customLinks = mainAction.APP_SETTINGS.customLinks;
      customLinks.forEach((item, index) => {
        if (properties?.debug?.developerMode || !item.debugModeOnly) {
          navItems.push({
            id: "customLink" + index,
            icon: item.faIcon,
            text: language === "de" ? item.text.de_DE : item.text.en_US,
            action: () => {
              setCurrentAppOverlay(
                new AppOverlayIFrame(
                  intl.formatMessage({ id: "menu.termsOfUse" }),
                  item.url
                )
              );
            },
          });
        }
      });
    }
  }

  if (!isTerminal) {
    navItems.push({
      id: "settings",
      icon: "cog",
      text: intl.formatMessage({ id: "menu.settings" }),
      action: () => {
        history.push(`/${pageNames.settings}/${getQueryParams()}`);
        triggerPageLoad();
      },
    });
  }
  const openPage = (action) => {
    setStatus("close");
    action();
  };

  return navItems.map((item) => (
    <StandardButton
      key={item.id}
      icon={["fal", item.icon]}
      handleClick={() => openPage(item.action)}
      buttonClasses={`${
        location.pathname.includes(item.id)
          ? "normalButton__mainNavigation--active"
          : ""
      } normalButton__mainNavigation`}
    >
      <span className="normalButton__mainNavigation__text">{item.text}</span>
    </StandardButton>
  ));
};
const LegalItems = ({ setCurrentAppOverlay, setShowContactForm }) => {
  const intl = useIntl();

  const legalItems = [
    {
      id: 1,
      text: intl.formatMessage({ id: "menu.termsOfUse" }),
      link: "#",
      action: () =>
        setCurrentAppOverlay(
          new AppOverlayIFrame(
            intl.formatMessage({ id: "menu.termsOfUse" }),
            `https://www.catchup-apps.com/nutzungsbedingungen-apps/?piKey=${piKey}`
          )
        ),
    },
    {
      id: 2,
      text: intl.formatMessage({ id: "menu.imprint" }),
      link: "#",
      action: () =>
        setCurrentAppOverlay(
          new AppOverlayIFrame(
            intl.formatMessage({ id: "menu.imprint" }),
            MISC_INFO.imprintURL
          )
        ),
    },
    {
      id: 3,
      text: intl.formatMessage({ id: "menu.dataProtection" }),
      link: "#",
      action: () =>
        setCurrentAppOverlay(
          new AppOverlayIFrame(
            intl.formatMessage({ id: "menu.dataProtection" }),
            MISC_INFO.dataProtectionURL
          )
        ),
    },
    {
      id: 4,
      text: intl.formatMessage({ id: "menu.contact" }),
      target: MISC_INFO.contactURL ? "_blank" : undefined,
      link: MISC_INFO.contactURL ?? "#",
      action: () => {
        if (MISC_INFO.contactURL) {
          window.location.href = MISC_INFO.contactURL;
        } else {
          setShowContactForm(true);
        }
      },
    },
  ];

  if (MISC_INFO.accessibilityURL != null) {
    legalItems.push({
      id: 5,
      text: intl.formatMessage({ id: "menu.accessibility" }),
      link: "#",
      action: () =>
        setCurrentAppOverlay(
          new AppOverlayIFrame(
            intl.formatMessage({ id: "menu.accessibility" }),
            MISC_INFO.accessibilityURL
          )
        ),
    });
  }

  return legalItems.map((legalItem) => (
    <StandardButton
      postfixIcon={["fal", "chevron-right"]}
      key={legalItem.id}
      icon={["fal", "globe"]}
      handleClick={legalItem.action}
      textClasses={
        "normalButton__mainNavigation__text normalButton__mainNavigation__legal__text"
      }
      buttonClasses={
        "normalButton__mainNavigation normalButton__mainNavigation__legal"
      }
    >
      {legalItem.text}
    </StandardButton>
  ));
};
const AppInfos = ({ setCurrentAppOverlay, appVersion, setProperties }) => {
  const [clicked, setClicked] = useState(0);
  const intl = useIntl();

  const handleClick = () => {
    setClicked((prevState) => prevState + 1);
  };

  const ownerItems = [
    {
      id: 1,
      title: intl.formatMessage({ id: "menu.developer" }),
      img: CALogo,
      link: "https://www.catchup-apps.com",
      action: () => {
        setCurrentAppOverlay(
          new AppOverlayIFrame("CatchUp", "https://www.catchup-apps.com")
        );
      },
    },
  ];
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    let tempPartners = [];
    try {
      MISC_INFO.partners?.[0].partners?.forEach((p, i) => {
        tempPartners.push({
          id: i,
          img: p.logo,
          link: p.url,
          action: () => {
            setCurrentAppOverlay(new AppOverlayIFrame("Partner", p.url));
          },
        });
      });
      setPartners(tempPartners);
    } catch (e) {}
  }, []);

  useEffect(() => {
    if (clicked > 4) {
      toggleDebugMode(true);
      setProperties({ debug: { developerMode: true } });
    }
  }, [clicked]);

  return (
    <>
      <div>
        <StandardInstruction className={"pl-3"}>
          <FormattedMessage id={"menu.appFrom"} />
        </StandardInstruction>
        {ownerItems.map((companyItem) => (
          <StandardButton
            key={companyItem.id}
            handleClick={companyItem.action}
            postfixIcon={["fal", "chevron-right"]}
            buttonClasses={
              "normalButton__mainNavigation normalButton__mainNavigation__appInfo"
            }
          >
            <div className={`p-0 mb-2 ${styles.companyLogo}`}>
              <img className={"w-100"} src={companyItem.img} />
            </div>
          </StandardButton>
        ))}
      </div>
      {partners.length > 0 && (
        <div>
          <StandardInstruction className={"pl-3"}>
            <FormattedMessage id={"menu.partners"} />
          </StandardInstruction>
          {partners.map((partner) => (
            <StandardButton
              key={partner.id}
              handleClick={partner.action}
              postfixIcon={["fal", "chevron-right"]}
              buttonClasses={
                "normalButton__mainNavigation normalButton__mainNavigation__appInfo"
              }
            >
              <div className={`p-0 mb-2 ${styles.companyLogo}`}>
                <img className={"w-100"} src={partner.img} />
              </div>
            </StandardButton>
          ))}
        </div>
      )}
      <StandardButton
        buttonClasses={
          "normalButton__mainNavigation normalButton__mainNavigation__appInfo"
        }
      >
        <div className={"d-flex flex-column align-items-start"}>
          <span
            className={
              "normalButton__mainNavigation__text normalButton__mainNavigation__appInfo__text"
            }
          >
            <FormattedMessage id="menu.appVersionText" />
          </span>
          <span>
            {process.env.REACT_APP_APP_VERSION_NAME}{" "}
            {appVersion ? " - Native: " + appVersion : ""}
          </span>
        </div>
      </StandardButton>
      <StandardButton
        handleClick={handleClick}
        buttonClasses={
          "normalButton__mainNavigation normalButton__mainNavigation__appInfo"
        }
      >
        <div className={"d-flex flex-column align-items-start"}>
          <span
            className={
              "normalButton__mainNavigation__text normalButton__mainNavigation__appInfo__text"
            }
          >
            <FormattedMessage id="menu.dataRevisionText" />
          </span>
          <span>{MISC_INFO.revision}</span>
        </div>
      </StandardButton>
      {clicked > 4 && (
        <div className={"w-100 overflow-auto"}>
          <div>Debug mode is now active</div>
          <div>Build time: {process.env.REACT_APP_BUILD_TIME}</div>
          <div>Domain: {window.location.href}</div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isTerminal: state.main.isTerminal,
    language: state.main.language,
    properties: state.settings,
    currentPage: state.main.currentPage,
    currentFeature: state.main.currentFeature,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setProperties: (props) => dispatch(setProperties(props)),
    setStatus: (status) => dispatch(action.setStatus(status)),
    triggerPageLoad: () => dispatch(mainAction.triggerPageLoad()),
    setCurrentAppOverlay: (appOverlay) =>
      dispatch(mainAction.setCurrentAppOverlay(appOverlay)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MainMenu)
);
